export enum LOCALE {
    ENGLISH = "en",
    SPANISH = "es",
    TURKISH = "tr",
    GERMAN = "de",
    ARABIC = "ar",
    ITALIAN = "it",
}

export enum CRM_LANGUAGE {
    ENG = "ENG",
    ES = "ES",
    DE = "DE",
    TR = "TR",
    ITA = "ITA",
    AR = "AR",
}

export const DEFAULT_CRM_LANGUAGE = CRM_LANGUAGE.ENG;

export const LOCALE_OPTIONS = [
    { value: LOCALE.ENGLISH, label: "English" },
    { value: LOCALE.SPANISH, label: "Español" },
    { value: LOCALE.TURKISH, label: "Türkçe" },
    { value: LOCALE.GERMAN, label: "Deutsch" },
    { value: LOCALE.ARABIC, label: "العربية" },
    { value: LOCALE.ITALIAN, label: "Italiano" },
];

export const LOCALE_LABELS: Record<LOCALE, string> = {
    [LOCALE.ENGLISH]: "English",
    [LOCALE.SPANISH]: "Español",
    [LOCALE.TURKISH]: "Türkçe",
    [LOCALE.GERMAN]: "Deutsch",
    [LOCALE.ARABIC]: "العربية",
    [LOCALE.ITALIAN]: "Italiano",
};
